/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-06-03 14:56
 * @LastEditors: 苏梦觎 mengyu.su@ginlong.com
 * @LastEditTime: 2026-03-26 20:33:18
 * @FilePath: \glyun_web_vue3\src\api\login\index.js
 * @Description: 登录
 */
import { post, get } from "../axios/index.js"
// console.log("🚀 ~ post:", post, get)
export const userLogin2 = async (parmas) => {
  const res = await post('/user/login2', parmas)
  return res || {}
}
// 三方登录
export const thirdLogin = async (parmas) => {
  const res = await post('/oauth/third/login', parmas)
  return res || {}
}
//授权码获取接口
export const postAuthorizationRedUrl = async (parmas,{oAuthToken}) => {
  const res = await post('/oauth/third/code', parmas,{oAuthToken})
  return res || {}
}
//第三方授权表格
export const thirdStationPermission = async (parmas,{oAuthToken}) => {
  const res = await post('/oauth/third/stationPermission', parmas,{oAuthToken})
  return res || {}
}
// app 下载的二维码
export const appQRCode = async (parmas) => {
  const res = await post('/system/qrCodeUrl', parmas)
  return res || {}
}
// app 扫描登录
export const QRcodeLogin = async (url, parmas) => {
  const res = await post('/user/vQrcodeLogin?sid='+url, parmas)
  return res || {}
}
// 第三方登录
export const find3partyWeb = async (parmas) => {
  const res = await post('/user/find3partyWeb', parmas)
  return res || {}
}
// 个人基本信息
export const userFind = async (parmas) => {
  const res = await post('/user/find', parmas)
  return res || {}
}
// 验证码图片
export const systemVimage = async (parmas, xhrFields) => {
  const res = await get('system/vimage', parmas ,xhrFields)
  return res || {}
}
// 注册验证
export const registerValidate = async (parmas) => {
  const res = await post('/register/validate', parmas)
  return res || {}
}
//微信登录绑定
export const userBind3party = async (parmas) => {
  const res = await post('/user/bind3party', parmas)
  return res || {}
}
// 内部邮箱验证
export const registervSendCodeGlEmail = async (parmas) => {
  const res = await post('/register/vSendCodeGlEmail', parmas)
  return res || {}
}
// 验证验证码
export const registerVSendCode = async (parmas) => {
  const res = await post('/register/vSendCode', parmas)
  return res || {}
}
// 添加常用登录设备
export const addInternalAccount = async (parmas) => {
  const res = await post('/user/addInternalAccount', parmas)
  return res || {}
}
// 忘记密码发送验证码(滑块验证专用)
export const registerSendCodeSlide = async (parmas) => {
  const res = await post('/register/sendCodeSlide', parmas)
  return res || {}
}
// 忘记密码发送验证码(登录页滑块验证专用)
export const registerSendCodeSlideCommon = async (parmas) => {
  const res = await post('/register/sendCodeSlideCommon', parmas)
  return res || {}
}
//获取滑块校验码
export const getSlideCaptcha = async (parmas) => {
  const res = await get('/system/getPatchaSlideCode?uuid='+parmas)
  return res || {}
}
//修改密码登录进去
export const registerModifyPassword1 = async (parmas) => {
  const res = await post('/register/modifyPassword1', parmas)
  return res || {}
}
//重置密码
export const registerModifyPassword = async (parmas) => {
  const res = await post('/register/modifyPassword', parmas)
  return res || {}
}

//注册验证(滑块验证专用 - 弱密码新加)
export const registerAppValidateSlide = async (parmas) => {
  const res = await post('/register/appValidateSlide', parmas)
  return res || {}
}


//弱密码库判断强弱 - 弱密码新加
export const securityCheckPwd = async (parmas) => {
  const res = await post('/security/checkPwd', parmas)
  return res || {}
}

export const systemCheckTokenValid = async (parmas) => {
  const res = await post('/system/checkTokenValid', parmas)
  return res || {}
}

export const userSwitchUiStyle = async (parmas) => {
  const res = await post('/user/switchUiStyle', parmas)
  return res || {}
}
// 安全滑块验证 - 邮箱（未登录）
export const sendVerifyCodeToEmailNoLogin = (data = {}) => { return post('/extend/shelf/sendVerifyCodeToEmailNoLogin', data)}
// 安全滑块验证 - 手机号（未登录）
export const sendVerifyCodeToMobileNoLogin = (data = {}) => { return post('/extend/shelf/sendVerifyCodeToMobileNoLogin', data)}
// 获取验证码类型配置：useNewCaptcha=true(新版hCaptcha/AJ) / false(老版滑块)
export const getCaptchaConfig = async (parmas) => {
  const res = await get('/captcha/config', parmas)
  return res || {}
}
